module.exports = __webpack_public_path__ + "static/media/location.72344b69.svg";